// extracted by mini-css-extract-plugin
module.exports = {"table-body":"TableBody_table-body__30JGV","editing-pricing":"TableBody_editing-pricing__22aT4","loading":"TableBody_loading__1D45O","loading-page":"TableBody_loading-page__3zgKw"};